import React from 'react';
import { endpoints } from 'endpoints.config';
import { downloadFile } from 'helpers/downloadFile';
import { openFile } from 'helpers/openFile';

type Props = {
  openCloseState?: string;
  checkboxList?: Array<number>;
  name?: string;
};

export const InvoicesMenuOptions: React.FC<Props> = ({
  openCloseState,
  checkboxList,
  name,
}) => {
  const downloadInvoice = () => {
    if (!checkboxList) return;
    downloadFile(
      endpoints.invoices.downloadInvoice +
        '?subscriptionHistoriesID=' +
        checkboxList[0],
      name ?? 'invoice' + checkboxList[0]
    );
  };

  return (
    <React.Fragment>
      <div className={`RightMenu ${openCloseState}`}>
        {checkboxList && checkboxList.length > 0 && (
          <div className="ItemsContainer">
            <div className="Item" onClick={() => openFile(checkboxList[0])}>
              <span>View Invoice</span>
            </div>
            <div className="Item" onClick={downloadInvoice}>
              <span>Download Invoice</span>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
